import type { CSSProperties } from 'react';

type InputValidationErrorProps = {
  message: string;
  style?: CSSProperties;
};

/** @deprecated use a POS form component which will handle error messaging dynamically through 'Control' */
export const InputValidationError = ({
  message,
  style,
}: InputValidationErrorProps) => {
  return (
    <span style={style} className="ant-form-item-explain-error">
      {message}
    </span>
  );
};
